import React, { Component } from 'react';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import moment from 'moment';
import { TranslateProvider, TranslateInstance } from 'autobiz-translate';
import './assets/scss/theme-a.scss';
import Cookies from 'js-cookie';
import Login from './components/Login/LoginForm';
import SectionsList from './components/Section/SectionsList';
import QuestionsList from './components/Question/QuestionsList';
import MarketAnalysis from './components/MarketAnalysis/MarketAnalysis';
import Content from './components/common/Content';
import AuthRequiredRoute from './config/Auth/AuthRequiredRoute';
import Alert from './components/common/Alert';
import FormSearch from './components/Form/FormSearch';
import RecordsList from './components/Form/RecordsList';
import initApp from './initApp';
import ReportList from './components/Report/ReportList';
import SupervisorList from './components/Form/SupervisorList';
import Calendar from './components/Calendar/Calendar';
import CreateFile from './components/Calendar/CreateFile';
import { Record } from './components/Calendar/Record';
import VehicleSearch from './components/SearchVehicle/VehicleSearch';
import CreateCalendar from './components/Calendar/CreateCalendar';
import AutobizTrade from './components/AutobizTrade/AutobizTrade';
// import { INTERVAL_CLEAN_FORMS as intervalCleanFormsConfig } from './config';
import Pricing from './components/Pricing/Pricing';
import Finalising from './components/Finalising/Finalising';
import Vincheck from './components/Vincheck/Vincheck';
import { Auth, messenger } from './config/configuration/react';
import { stage } from './Utils/getStage';
import PdfCost from './components/Pdf/PdfCost';
import GuaranteedPrice from './components/GuaranteedPrice/GuaranteedPrice';
import DashboardNrmRecords from './components/DashboardNrm/DashboardNrm';
import DetectNetworkStatus from './components/common/DetectNetworkStatus';
import Auth0ProviderWithNavigate from './Auth0ProviderNavigate';
/* import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
library.add(fas, far);
 */

const intervalSync = null;

class App extends Component {
  languages = process.env.REACT_APP_LANGUAGES.split(',');

  constructor(props) {
    super(props);
    this.state = {
      language: '',
      displayAlertWhenOffline: true,
      alerts: {},
    };
  }

  UNSAFE_componentWillMount() {
    const language = Cookies.get('appLanguage') || process.env.REACT_APP_LANG;
    this.setState({ language });
    window.addEventListener('changeLanguage', this.handleChangeLanguage);
    window.addEventListener('storage', this.handleRefresh);
    initApp().then(() => {
      const { alerts: newAlerts, displayAlertWhenOffline: newDisplayAlerts } = this.state;
      this.setState({ alerts: newAlerts, displayAlertWhenOffline: newDisplayAlerts });
    });
  }

  componentDidMount() {
    window.addEventListener('addAlert', this.handleNvEnter);
    // setInterval(this.syncLoop, intervalCleanFormsConfig);
    // messenger.sendMessage('resetImages', '');
    // messenger.sendMessage('resetForms', '');
  }

  componentWillUnmount() {
    clearInterval(intervalSync);
    window.removeEventListener('storage', this.handleRefresh);
    this.setState({ displayAlertWhenOffline: true });
    return () => {
      window.removeEventListener('addAlert', this.handleNvEnter);
      window.removeEventListener('changeLanguage', this.handleChangeLanguage);
    };
  }

  hideOfflineAlert = () => {
    this.setState({ displayAlertWhenOffline: false });
  };

  hidelert = (key) => {
    const { alerts: stateAlerts } = this.state;
    const alerts = { ...stateAlerts };
    delete alerts[key];
    this.setState({ alerts });
  };

  changeLanguage = async (language) => {
    moment.locale(language);
    localStorage.removeItem('translation');
    await TranslateInstance.init('carcheck-app', Cookies.get('appLanguage') || language, stage);
    this.setState({ language });
  };

  handleChangeLanguage = async (event) => {
    if (event.detail.language) {
      await this.changeLanguage(event.detail.language);
    }
  };

  addAlert = (alert) => {
    const newalert = alert;
    const key = Object.getOwnPropertyNames(newalert);
    newalert[key].onClose = () => this.hidelert(key);
    newalert[key].visible = true;
    this.setState((prevState) => ({
      alerts: {
        ...prevState.alerts,
        ...newalert,
      },
    }));
  };

  handleNvEnter = (event) => {
    if (event.detail) {
      this.addAlert(event.detail);
    }
  };

  handleRefresh = async (e) => {
    if (e.key === 'carcheck.staticContent') {
      this.changeLanguage(Auth.preferredLanguage());
    }
  };

  syncLoop = () => {
    if (!window.navigator.onLine) return;
    messenger.sendMessage('syncImages', '');
    messenger.sendMessage('syncAllAnswers', '');
    messenger.sendMessage('syncForms', '');
  };

  render() {
    const { alerts, language, displayAlertWhenOffline } = this.state;
    let offlineAlert;
    if (displayAlertWhenOffline) {
      offlineAlert = (
        <>
          <DetectNetworkStatus>
            <Alert color="warning" visible={displayAlertWhenOffline} hideOfflineAlert={this.hideOfflineAlert}>
              no_signal
            </Alert>
          </DetectNetworkStatus>
        </>
      );
    }

    return (
      <BrowserRouter>
        {language ? (
          <Auth0ProviderWithNavigate>
            <TranslateProvider projectName="carcheck-app" stage={stage} language={language}>
              {/* <LanguageContext.Provider value={language}> */}
              <Switch>
                <AuthRequiredRoute
                  path="/calendar/create"
                  render={(props) => <CreateCalendar {...props} alert={offlineAlert} alerts={alerts} />}
                />
                <AuthRequiredRoute
                  path="/files/create"
                  render={(props) => <CreateFile {...props} alert={offlineAlert} alerts={alerts} />}
                />
                <AuthRequiredRoute
                  path="/files/:recordId/identification"
                  render={(props) => <VehicleSearch {...props} alert={offlineAlert} alerts={alerts} />}
                />
                <AuthRequiredRoute
                  path="/files/:recordId/market"
                  render={(props) => <MarketAnalysis {...props} alert={offlineAlert} alerts={alerts} />}
                />
                <AuthRequiredRoute
                  path="/files/:recordId/pushAt"
                  render={(props) => <AutobizTrade {...props} alert={offlineAlert} alerts={alerts} />}
                />
                <AuthRequiredRoute
                  path="/files/:recordId/pricing"
                  render={(props) => <Pricing {...props} alert={offlineAlert} alerts={alerts} />}
                />
                <AuthRequiredRoute
                  path="/files/:recordId/vincheck"
                  render={(props) => <Vincheck {...props} alert={offlineAlert} alerts={alerts} />}
                />
                <AuthRequiredRoute
                  path="/files/:recordId/finalising"
                  render={(props) => <Finalising {...props} alert={offlineAlert} alerts={alerts} />}
                />
                <AuthRequiredRoute
                  path="/files/:recordId/garanteed-price"
                  render={(props) => <GuaranteedPrice {...props} alert={offlineAlert} alerts={alerts} />}
                />
                <AuthRequiredRoute
                  path="/files/:recordId"
                  render={(props) => <Record {...props} alert={offlineAlert} alerts={alerts} />}
                />
                <AuthRequiredRoute
                  path="/calendar"
                  render={(props) => <Calendar {...props} alert={offlineAlert} alerts={alerts} />}
                  allowedJourneys={[1]}
                  redirectPath="/dashboardnrm"
                />

                <AuthRequiredRoute
                  path="/dashboardnrm"
                  render={(props) => <DashboardNrmRecords {...props} alert={offlineAlert} alerts={alerts} />}
                  allowedJourneys={[2]}
                  redirectPath="/forms"
                />
                <AuthRequiredRoute
                  path="/report/:formId"
                  render={(props) => <ReportList {...props} alert={offlineAlert} alerts={alerts} />}
                />
                <AuthRequiredRoute
                  path="/forms/:formId/:sectionId/:questionId"
                  render={(props) => <QuestionsList {...props} alert={offlineAlert} alerts={alerts} />}
                />
                <AuthRequiredRoute
                  path="/forms/:formId/:sectionId"
                  render={(props) => <QuestionsList {...props} alert={offlineAlert} alerts={alerts} />}
                />
                <AuthRequiredRoute
                  path="/forms/:formId"
                  render={(props) => <SectionsList {...props} alert={offlineAlert} alerts={alerts} />}
                />
                <AuthRequiredRoute
                  path="/forms"
                  render={(props) => <RecordsList {...props} alert={offlineAlert} alerts={alerts} />}
                  allowedJourneys={[1]}
                  redirectPath="/dashboardnrm"
                />
                <AuthRequiredRoute
                  path="/supervision"
                  render={(props) => <SupervisorList {...props} alert={offlineAlert} alerts={alerts} />}
                  allowedJourneys={[1]}
                  redirectPath="/dashboardnrm"
                />
                <AuthRequiredRoute
                  path="/search"
                  render={(props) => <FormSearch {...props} alert={offlineAlert} alerts={alerts} />}
                />
                <Route path="/login" render={(props) => <Login {...props} />} />
                <Route
                  path="/content/:contentSlug"
                  render={(props) => <Content {...props} alert={offlineAlert} alerts={alerts} />}
                />
                <Route path="/pdf/:recordKey/cost/:referential/:language" render={() => <PdfCost />} />
                <Redirect from="/" exact to="/forms" />
              </Switch>
              {/* </LanguageContext.Provider> */}
            </TranslateProvider>
          </Auth0ProviderWithNavigate>
        ) : null}
      </BrowserRouter>
    );
  }
}

export default App;
